module.exports = __webpack_public_path__ + "static/media/hospital2.fe60ffa4.jpg";